<!-- 工控-产品入库管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <select2
          labelName="NameNumber"
          v-model="former.IpcProductModelID"
          url="ipc/model/product/list?order=name"
          clearable
          placeholder="选择产品型号"
          no-data-text="没有产品型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
          style="width:300px"
        ></select2
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.Status"
          url="ipc/product/stock-status-list"
          clearable
          placeholder="请选择状态"
          no-data-text="没有状态"
        ></select2
        >&nbsp;
        <el-input
          v-model.trim="key"
          placeholder="产品SN/机器码"
          @keydown.enter.native="onSubmitQuery"
          style="width:300px"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="IpcProductModel.Name" label="产品型号名称" />
      <el-table-column prop="IpcProductModel.Number" label="产品型号" />
      <el-table-column prop="SN" label="产品SN" >
         <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
        </template>
      </el-table-column>
       <el-table-column prop="MachineCode" label="机器码" width="350">
         <template slot-scope="{ row }">
          <el-tag type="success">
            {{ row.MachineCode }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="入库日期" align="center" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.StockinAt">
            {{ scope.row.StockinAt.substring(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.Status === 1" type="warning">
            {{ row.StatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteClick(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <edit
      v-model="item"
      :visible.sync="editVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import Edit from "./edit.vue";

export default {
  components: {
    Edit,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        IpcProductModelID: "",
        Status: "",
      },
      key:"",
      item: this.getEmptyItem(),
      editVisible: false,
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("ipc/product/stock-in-list", {
          params: {
            where: this.former,
            key:this.key,
            ...this.pager,
            with: ["IpcProductModel", "IpcAccessories.IpcAccessoryModel"],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // onCreateItem() {
    //   this.item = this.getEmptyItem();
    //   this.createVisible = true;
    // },
    onEditItem(row) {
      this.item = row;
      this.editVisible = true;
    },
    onDeleteClick(row) {
      this.$confirm("确定要删除此产品吗？", "提示")
        .then(() => this.$axios.delete(`ipc/product/stock-in-delete/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {};
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
  },
};
</script>
